import {TextField} from '@material-ui/core';
import React from 'react';

export function TextFieldNumber(props) {
    if (!props.InputProps.inputProps)
        props.InputProps.inputProps = {};
    props.InputProps.inputProps.inputMode = 'numeric';
    return <TextField {...props}/>
}